/**
 * @generated SignedSource<<9efa7905c44995aa9f113e9c3f0f0430>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentTypeOnScheduleSwitch_assignmentType",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        }
    ],
    "type": "AssignmentType",
    "abstractKey": null
};
node.hash = "9213729a4b1ca48a6497eb93b4e4337b";
export default node;
